/**
 * Interceptors support following methods:
 * request, response, requestError, responseError
 */

(function () {
	angular
		.module('trackeye')
		.factory('PartialsCacheBuster', PartialsCacheBuster);

	PartialsCacheBuster.$inject = ['AppFactory'];

	function PartialsCacheBuster(app) {
		var exports = {},
			regex = new RegExp('(partials\/.*\.html)|(\.json)');

		exports.request = function (config) {
			if (config.url.match(regex)) {
				config.url += app.getAppVersion('?');
			}
			return config;
		};

		return exports;
	}
})();